import React from 'react';
import { Button, Dropdown, Menu } from 'semantic-ui-react';

import { InputTimeout } from 'src/componentes/semantic-ui-extended';
import { DatosDeContactoDeAlumno, FiltroArea, FiltroAño } from './tipos';

const styleMenuItem: React.CSSProperties = {
    paddingLeft: '5px',
};

const nombreDeFiltroArea: Record<FiltroArea, string> = {
    todas: 'Ambas áreas',
    preu: 'Solo preuniversitario',
    ingles: 'Solo inglés',
};
const nombreDeFiltroAño: Record<FiltroAño, string> = {
    2021: 'Año 2021',
    2020: 'Año 2020',
    2019: 'Año 2019',
    todos: 'Cualquier año',
};

export const MenuSuperior = (props: {
    cargando: boolean;
    matriculas: ReadonlyArray<DatosDeContactoDeAlumno>;
    filtroArea: FiltroArea;
    filtroAño: FiltroAño;
    alCambiarFiltroDeArea: (filtro: FiltroArea) => void;
    alCambiarFiltroDeAño: (filtro: FiltroAño) => void;
    alCambiarTextoDeBusqueda: (texto: string) => void;
    alPresionarRecargar: () => void;
}) => {
    const {
        cargando,
        matriculas,
        filtroArea,
        filtroAño,
        alCambiarFiltroDeArea,
        alCambiarFiltroDeAño,
        alCambiarTextoDeBusqueda,
        alPresionarRecargar,
    } = props;

    return (
        <Menu borderless size='large' attached='top' style={{ backgroundColor: '#f0f0ff' }}>
            <Menu.Item fitted style={styleMenuItem}>
                <Button basic icon='refresh' loading={cargando} onClick={alPresionarRecargar} />
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <InputTimeout
                    style={{ height: '40px', width: '450px' }}
                    icon='search'
                    milliseconds={300}
                    placeholder='nombre, rut del alumno, correo del alumno o nº de contrato'
                    onTimeout={(_e, { value }) => alCambiarTextoDeBusqueda(value)}
                    enableLoader={text => text.length >= 3}
                    autoFocus
                />
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Dropdown fitted='vertically' text={nombreDeFiltroArea[filtroArea]} item>
                    <Dropdown.Menu>
                        <Dropdown.Item
                            onClick={() => alCambiarFiltroDeArea('preu')}
                            content={nombreDeFiltroArea.preu}
                        />
                        <Dropdown.Item
                            onClick={() => alCambiarFiltroDeArea('ingles')}
                            content={nombreDeFiltroArea.ingles}
                        />
                        <Dropdown.Item
                            onClick={() => alCambiarFiltroDeArea('todas')}
                            content={nombreDeFiltroArea.todas}
                        />
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Dropdown fitted='vertically' text={nombreDeFiltroAño[filtroAño]} item>
                    <Dropdown.Menu>
                        <Dropdown.Item
                            onClick={() => alCambiarFiltroDeAño(2021)}
                            content={nombreDeFiltroAño[2021]}
                        />
                        <Dropdown.Item
                            onClick={() => alCambiarFiltroDeAño(2020)}
                            content={nombreDeFiltroAño[2020]}
                        />
                        <Dropdown.Item
                            onClick={() => alCambiarFiltroDeAño(2019)}
                            content={nombreDeFiltroAño[2019]}
                        />
                        <Dropdown.Item
                            onClick={() => alCambiarFiltroDeAño('todos')}
                            content={nombreDeFiltroAño.todos}
                        />
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>

            <Menu.Item position='right'>{matriculas.length} alumnos</Menu.Item>
        </Menu>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/ListaGeneral/MenuSuperior.tsx